import { useFormikContext } from "formik";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useTramite } from "../context/Tramite";
import { isInvalid } from "../utils/forms";
import "./css/components.css";
import { isEditable } from "../utils/tramite";
import { crearRepresentanteTecnico } from "../utils/data";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import ObjectField from "./controls/ObjectField";
import TextField from "./controls/TextField";

export default function RepresentanteTecnicoForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const [loading, setLoading] = useState(false);
  const handleRepresentanteTecnicoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (!tramiteForm.values.representanteTecnico) {
      tramiteForm.setFieldValue(
        "representanteTecnico",
        crearRepresentanteTecnico(),
        false,
      );
    }
  }, [tramiteForm]);
  useEffect(() => {
    setLoading(!tramite);
  }, [tramite]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col>
            <ObjectField
              id="representanteTecnico"
              name="representanteTecnico"
              value={tramiteForm.values.representanteTecnico}
              onChange={handleRepresentanteTecnicoChange}
              disabled={!isEditable(tramite)}
            >
              {({ value, setProperty, disabled }) => (
                <Grid>
                  <Row>
                    <Col lg={3}>
                      <TextField
                        id="representanteTecnico_documento"
                        name="representanteTecnico.documento"
                        label={t("representante.documento")}
                        value={value?.documento}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("documento", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteTecnico.documento",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteTecnico?.documento,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={9}>
                      <TextField
                        id="representanteTecnico_nombre"
                        name="representanteTecnico.nombre"
                        label={t("representante.nombre")}
                        value={value?.nombre}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("nombre", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteTecnico.nombre",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteTecnico?.nombre,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <TextField
                        id="representanteTecnico_cargo"
                        name="representanteTecnico.cargo"
                        label={t("representante.cargo")}
                        value={value?.cargo}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("cargo", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteTecnico.cargo",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteTecnico?.cargo,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={6}>
                      <TextField
                        id="representanteTecnico_titulo"
                        name="representanteTecnico.titulo"
                        label={t("representante.titulo")}
                        value={value?.titulo}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("titulo", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteTecnico.titulo",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteTecnico?.titulo,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}>
                      <TextField
                        id="representanteTecnico_telefono"
                        name="representanteTecnico.telefono"
                        label={t("representante.telefono")}
                        value={value?.telefono}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("telefono", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteTecnico.telefono",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteTecnico?.telefono,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={9}>
                      <TextField
                        id="representanteTecnico_correoElectronico"
                        name="representanteTecnico.correoElectronico"
                        label={t("representante.correoElectronico")}
                        value={value?.correoElectronico}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("correoElectronico", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteTecnico.correoElectronico",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteTecnico
                            ?.correoElectronico,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <ObjectField
                        id="representanteTecnico_matricula"
                        name="representanteTecnico.matricula"
                        value={value?.matricula}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("matricula", event.target.value);
                        }}
                        disabled={disabled}
                      >
                        {({ value, setProperty, disabled }) => (
                          <Grid>
                            <Row>
                              <Col lg={3}>
                                <TextField
                                  id="representanteTecnico_matricula_numero"
                                  name="representanteTecnico.matricula.numero"
                                  label={t("matricula.numero")}
                                  value={value?.numero}
                                  onChange={(event) => {
                                    event.preventDefault();
                                    setProperty("numero", event.target.value);
                                  }}
                                  isInvalid={isInvalid(
                                    "representanteTecnico.matricula.numero",
                                    tramiteForm,
                                  )}
                                  error={t(
                                    tramiteForm.errors.representanteTecnico
                                      ?.matricula?.numero,
                                  )}
                                  disabled={disabled}
                                />
                              </Col>
                              <Col lg={9}>
                                <TextField
                                  id="representanteTecnico_matricula_ente"
                                  name="representanteTecnico.matricula.ente"
                                  label={t("matricula.ente")}
                                  value={
                                    tramiteForm.values.representanteTecnico
                                      ?.matricula?.ente
                                  }
                                  onChange={(event) => {
                                    event.preventDefault();
                                    setProperty("ente", event.target.value);
                                  }}
                                  isInvalid={isInvalid(
                                    "representanteTecnico.matricula.ente",
                                    tramiteForm,
                                  )}
                                  error={t(
                                    tramiteForm.errors.representanteTecnico
                                      ?.matricula?.ente,
                                  )}
                                  disabled={disabled}
                                />
                              </Col>
                            </Row>
                          </Grid>
                        )}
                      </ObjectField>
                    </Col>
                  </Row>
                </Grid>
              )}
            </ObjectField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
